/* eslint-disable consistent-return */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Image, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { mobileComputer, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function DesktopContentPreview({ srcs, redirectUrl }) {
  const BackgroundImg = srcs.find((s) => s.label === 'Video or Image')

  const [showFloatingAd, setShowFloatingAd] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)
  const adRef = useRef(null)
  const containerRef = useRef(null)

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string') return file
    return ''
  }

  const isVideo = (entry) => {
    if (!entry) return false

    if (typeof entry.type === 'string') {
      return entry.type.startsWith('video')
    }

    if (typeof entry.file === 'string') {
      return entry.file.endsWith('.mp4') || entry.file.startsWith('blob:')
    }

    return false
  }

  useEffect(() => {
    const adElement = adRef.current
    if (!adElement || isDismissed) return

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        setShowFloatingAd(!entry.isIntersecting && !isDismissed)
      },
      {
        root: null,
        threshold: 0.5,
      }
    )

    observer.observe(adElement)
    return () => observer.disconnect()
  }, [isDismissed])

  return (
    <div
      ref={containerRef}
      className="scroller-hide"
      style={{
        maxHeight: '30.5vh',
        width: '100%',
        height: 'auto',
        overflow: 'auto',
        marginTop: '20%',
      }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobileComputer}
          style={{ width: '38rem', right: '3%', bottom: '25%' }}
        />
        <Row
          className="d-flex border-bottom mb-3"
          style={{ width: '100%', height: '55px', zIndex: '0' }}
        >
          <Col xs={11} className="w-90 m-auto ms-auto">
            <Image
              src={wavenet_logo}
              style={{ height: '45px' }}
              className="ps-3"
            />
          </Col>
          <Col
            xs={1}
            className="m-auto ms-auto d-flex"
            style={{ height: '45px' }}
          >
            <FontAwesomeIcon
              icon={faMagnifyingGlass}
              className="text-end my-auto"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={9} style={{ height: 'auto' }}>
            <div style={{ position: 'relative' }}>
              <div className="text-title" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-ban1" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line2" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
            </div>
            {BackgroundImg?.file && (
              <div
                ref={adRef}
                style={{
                  width: '100%',
                  position: 'relative',
                  zIndex: 10,
                }}
              >
                {isVideo(BackgroundImg) ? (
                  <video
                    onClick={() => {
                      if (redirectUrl) window.open(redirectUrl, '_blank')
                    }}
                    src={getPreviewURL(BackgroundImg.file)}
                    autoPlay
                    controls
                    muted
                    loop
                    playsInline
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'contain',
                      cursor: 'pointer',
                      zIndex: 10,
                      position: 'relative',
                    }}
                    className="px-3 py-2"
                  />
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      if (redirectUrl) window.open(redirectUrl, '_blank')
                    }}
                    style={{
                      border: 'none',
                      padding: 0,
                      background: 'transparent',
                      cursor: 'pointer',
                      width: '100%',
                      zIndex: 10,
                    }}
                  >
                    <img
                      src={getPreviewURL(BackgroundImg.file)}
                      alt="Background"
                      style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                      className="px-3 py-2"
                    />
                  </button>
                )}
                <CIIcon bottom="8%" right="5%" />
              </div>
            )}

            {showFloatingAd && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '32%',
                  right: '10%',
                  width: '150px',
                  height: 'auto',
                  zIndex: 3000,
                  boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                  background: '#000',
                  borderRadius: '6px',
                  overflow: 'hidden',
                }}
              >
                {isVideo(BackgroundImg) ? (
                  <video
                    src={getPreviewURL(BackgroundImg.file)}
                    autoPlay
                    muted
                    controls
                    loop
                    playsInline
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <img
                    src={getPreviewURL(BackgroundImg.file)}
                    alt="Mini Ad"
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                )}
                <button
                  type="button"
                  onClick={() => {
                    setIsDismissed(true)
                    setShowFloatingAd(false)
                  }}
                  style={{
                    position: 'absolute',
                    top: '4px',
                    right: '4px',
                    background: 'rgba(0,0,0,0.5)',
                    border: 'none',
                    color: '#fff',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    zIndex: 9999,
                  }}
                >
                  ✕
                </button>
              </div>
            )}
          </Col>
          <Col xs={3}>
            <div style={{ position: 'relative' }}>
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <br />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <br />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <br />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
              <div className="text-line" />
            </div>
          </Col>
        </Row>
      </div>

      <div style={{ position: 'relative' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

DesktopContentPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  redirectUrl: PropTypes.string,
}

DesktopContentPreview.defaultProps = {
  srcs: [],
  redirectUrl: '',
}

export default DesktopContentPreview
